import { businessErrorFactory, BusinessError } from '../../../business-error';

import { DELETE_REPORT_BUSINESS_ERRORS } from './interfaces';

const DELETE_REPORT_UNEXPECTED_ERROR =
  // eslint-disable-next-line max-len
  'Sorry we ran into an unexpected error and report could not be deleted. Please try again. If the problem still persists, contact with support.';

const DELETE_REPORT_REPORT_NOT_FOUND =
  // eslint-disable-next-line max-len
  'Sorry but this report could not be found and deleted. It is possible that the report has already been deleted. Please refresh the page. If the problem still persists, contact with support.';

export const getDeleteReportBusinessError = (businessError: DELETE_REPORT_BUSINESS_ERRORS): BusinessError => {
  switch (businessError) {
    case DELETE_REPORT_BUSINESS_ERRORS.REPORT_NOT_FOUND: {
      return businessErrorFactory({ message: DELETE_REPORT_REPORT_NOT_FOUND, severity: 'warning' });
    }
    default: {
      return businessErrorFactory({
        message: DELETE_REPORT_UNEXPECTED_ERROR,
        severity: 'error'
      });
    }
  }
};
